export default __webpack_public_path__ + "static/media/badgepercent-1-1.987a5b30.svg";